/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 16:12:39
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-10-11 21:53:50
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import '@/style/reset.css'
import '@/style/common.scss'
import 'amfe-flexible/index'
import fastClick from 'fastclick'
import { setLocal, getLocal, getCookie } from '@/utils/cookie'
import { handlePhone } from './utils/util'
import { loginUrl } from '@/utils/config'

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)

fastClick.attach(document.body)

import {
  Notify,
  Form,
  Field,
  Search,
  Button,
  Popup,
  Picker,
  Uploader,
  RadioGroup,
  Radio,
  Dialog,
  Icon,
  Image as VanImage,
  Swipe,
  SwipeItem,
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Loading
} from 'vant'

Vue.use(Notify)
Vue.use(Form)
Vue.use(Field)
Vue.use(Search)
Vue.use(Button)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Uploader)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(VanImage)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Loading)

Vue.prototype.$setLocal = setLocal
Vue.prototype.$getLocal = getLocal
// Vue.prototype.$resetLocal = reSetLocal
Vue.prototype.$getCookie = getCookie

Vue.prototype.$loginUrl = loginUrl

Vue.prototype.$handlePhone = handlePhone

Vue.prototype.$dialog = Dialog.alert
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
